import MoreVertIcon from '@material-ui/icons/MoreVert';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsExport from 'highcharts/modules/export-data';
import HighchartsExporting from 'highcharts/modules/exporting';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Content, Dropdown, Popover, Whisper } from 'rsuite';
import { LoadingSpinerLocal } from '../../../../../../components';
import * as utils from '../../utils';
import styles from './HistoricoCoberturaChart.module.scss';

HighchartsExporting(Highcharts);
HighchartsExport(Highcharts);

Highcharts.setOptions(utils.HighchartsOptions);

export const HistoricoCoberturaChart = ({ data, isLoading, onSelectThreeDotButtonOption }) => {
  const [classStyle, setClassStyle] = useState('container');

  const historicoCoberturaChartRef = useRef(null);

  const defaultChartOption = {
    chart: {
      type: 'spline',
      height: 310,
    },
    title: {
      text: '',
    },

    exporting: {
      enabled: false,
    },
    tooltip: {
      pointFormatter(this: any) {
        return `
                    <span style="color:#E663C9"><b>●</b></span>
                    ${this.series.name}: <b>${this.y.toString().replace('.', ',')}%</b>
                `;
      },
      headerFormat: '<b>{point.key}</b><br/>',
    },
    legend: {
      symbolWidth: 50,
    },
    yAxis: [
      {
        title: {
          text: 'PERCENTUAL DE COBERTURA',
        },
        breakSize: 50,
        alignTicks: false,
        labels: {
          formatter(this: any) {
            const cobertura = this.axis.defaultLabelFormatter.call(this);
            return `${cobertura.replace(',', '.')}%`;
          },
        },
      },
    ],
    xAxis: {
      type: 'datetime',
      title: {
        text: 'TEMPO',
      },
      categories: utils.xAxis(data?.content),
    },
    plotOptions: {},
    series: [
      {
        name: 'Cobertura Infopanel',
        data: utils.yAxis(data?.content),
        color: '#E663C9',
      },
    ],
  };

  const MenuPopover = ({ onSelect, ...rest }) => (
    <Popover {...rest} full>
      <Dropdown.Menu onSelect={onSelect} style={{ width: '196px' }}>
        <Dropdown.Item eventKey={1}>Download</Dropdown.Item>
      </Dropdown.Menu>
    </Popover>
  );

  useEffect(() => {
    setClassStyle('container-timeout');
  }, []);

  return (
    <Content className={styles[classStyle]}>
      <LoadingSpinerLocal loading={isLoading} size="md" />

      <div className={styles.header}>
        <h6 className={styles.title}>HISTÓRICO DE COBERTURA</h6>
        <Whisper placement="bottomEnd" trigger="click" speaker={<MenuPopover onSelect={key => onSelectThreeDotButtonOption(key)} />}>
          <Button className={styles['btn-popover']}>
            <MoreVertIcon className={styles['icon-more-vert']} />
          </Button>
        </Whisper>
      </div>
      <HighchartsReact ref={historicoCoberturaChartRef} highcharts={Highcharts} options={defaultChartOption} />
    </Content>
  );
};
